function page(path) {
    return () => import(/* webpackChunkName: '' */ `~/views/${path}`).then((m) => m.default || m);
}
export default [
    /* {
        path: '/',
        name: 'home',
        component: page('home.vue'),
    }, */
    {
      path: '/',
      name: 'home',
      component: page('indicator.vue'),
    },
];
